import { RouteObject } from "react-router-dom";
import { Activities } from "./list";

export const ActivityRouter: RouteObject = {
  path: "/activities",
  handle: { crumb: () => "Cadastros / Geral / Atividades" },
  children: [
    {
      index: true,
      element: <Activities />,
    },
  ],
  errorElement: <h1>Route not found!</h1>,
};
